/* eslint-disable no-unused-vars */
/* eslint-disable new-cap */

import handorgel from 'handorgel/lib/js/esm/handorgel.js';

const options = {
  multiSelectable: false,
  initialOpenAttribute: '',
  initialOpenTransition: true
};

if (document.querySelector('.handorgel')) {
  const accordion = new handorgel(document.querySelector('.handorgel'), options);

  window.handOrgelExpand = function () {
    return {
      expanded: false,
      toggleExpand() {
        this.expanded = !this.expanded;
      }
    };
  };
}
